import { inject, Injectable } from "@angular/core";

import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { StorageService, StorageType } from "gast-common-ng2";
import { AuthService } from "../auth";
const COOKIE_DUO_URL_PARAMs = "duo-url-params";

/**
 * helper class to handle url param from cookie
 */
@Injectable({
  providedIn: "root",
})
export class UrlParamService {
  readonly #storageService = inject(StorageService);
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);
  readonly #authService = inject(AuthService);

  /**
   * restore url params
   * NOTE: currently only for DUO
   */
  restoreUrlParams(): void {
    const urlParams = this.#storageService.getItem(COOKIE_DUO_URL_PARAMs, StorageType.Session);
    if (urlParams) {
      const params = decodeURIComponent(
        this.#storageService.getItem(COOKIE_DUO_URL_PARAMs, StorageType.Session) as string
      );
      console.log("restore url param: " + params);
      const jsonParam = JSON.parse(params);
      this.#storageService.removeItem(COOKIE_DUO_URL_PARAMs, StorageType.Session);
      this.#router.navigate([], {
        relativeTo: this.#route,
        queryParams: jsonParam,
        queryParamsHandling: "merge",
      });
    }
  }

  saveSessionFromParamAndRemoveParam(paramMap: ParamMap) {
    // return if no relevant param found
    if (!paramMap.has(this.#authService.getSessionIdKey())) {
      return;
    }

    // save session in storage
    const sessionId = paramMap.get(this.#authService.getSessionIdKey()) as string;
    this.#authService.saveSessionIdInStorage(sessionId);

    // add param for removal to list
    const keyToRemove = [];
    keyToRemove.push(this.#authService.getSessionIdKey());

    // remove param
    this.#removeParamFromUrl(paramMap, keyToRemove);
  }

  #removeParamFromUrl(paramMap: ParamMap, keysToRemove: string[]) {
    const queryParams: Record<string, string> = {};
    const keysToKeep = paramMap.keys.filter((k) => !keysToRemove.includes(k));
    keysToKeep.forEach((k) => (queryParams[k] = paramMap.get(k) as string));

    this.#router.navigate([], { queryParams, replaceUrl: true, relativeTo: this.#route });
  }
}
